/**
 * PC_EDF_01 importing the api functions and react functions
 */
import { useState, useEffect } from 'react';
import React from 'react';
import { postFeedbackResponse } from '../service/DirectorAPI';
import { OnlyNumberSpecialChar, NotificationTrigger } from '../../src/utils/RegHandling';
import $ from 'jquery';
import { connect } from 'react-redux';

import { encryptStorage } from '../constant';

/**
 *
 * PC_EDF_01.1 this function will return the html
 */
function EmpDisagreeFeedback(props) {
    /**
     * PC_EDF_02 creating objects state variables
     */

    let FeedbackData = {
        Comments: '',
    };

    const [feedbackdata, setFeedbackdata] = useState(FeedbackData);
    let empId = props.empId;
    let FeedbackId = props.FeedbackId;
    let EvaluationId = props.EvaluationId;
    let FeedbackDataId = props.feedbackDataID;
    let flags = props.Flag;
    let login_emp_id = encryptStorage.getItem('employeeId');
    let role = encryptStorage.getItem('role');
    let CurrentEvaluationId = encryptStorage.getItem('CurrentEvaluationId');
    const [hideForm, setHideForm] = useState(true);

    let validationFields = {
        Comments: '',
    };
    const [message, setmessage] = useState(validationFields);

    /**
     * PC_EDF_03 this method setstate the HideForm value as false
     */
    useEffect(() => {
        if (props.EmpDisagreeClicked) {
            setHideForm(false);
            // let element = document.getElementById("removeScroll");
            // element.classList.add("removeScroll");
            $('body').addClass('removeScroll');
        }
    }, [props]);

    /**
     * PC_EDF_04 validation is happen here
     */
    const OnChangeName = (e) => {
        setFeedbackdata({ ...feedbackdata, [e.target.name]: e.target.value });
    };

    /**
     * PC_EDF_05 validation is happen here
     */
    const validation = () => {
        if (feedbackdata.Comments == '') {
            message.Comments = 'Disagree comments is required';
            setmessage({ ...message });
        } else {
            message.Comments = '';
            setmessage({ ...message });

            let checkregex = OnlyNumberSpecialChar(feedbackdata.Comments);
            if (checkregex) {
                message.Comments = 'Enter a valid Disagree comments';
                setmessage({ ...message });
            } else {
                message.Comments = '';
                setmessage({ ...message });
            }
        }
    };

    /**
     * PC_EDF_13 this function clear the all variables value
     */
    const cancelClick = () => {
        let valiclearoption = {
            Comments: '',
        };
        setFeedbackdata(valiclearoption);

        let validationFields = {
            Comments: '',
        };
        setmessage(validationFields);
        props.setEmpDisagreeClicked(false);
        setHideForm(true);

        // let element = document.getElementById("removeScroll");
        // element.classList.remove("removeScroll");
        $('body').removeClass('removeScroll');
    };

    /**
     * PC_EDF_06 this function post the data into the db
     * after completing the validation check
     */
    const submitClick = async () => {
        try {
            validation();

            if (feedbackdata.Comments != '' && message.Comments == '') {
                let insertdata = {
                    emp_response: 'Disagree',
                    emp_comments: feedbackdata.Comments,
                    id: FeedbackId,
                    emp_id: empId,
                    evaluation_id: EvaluationId,
                    feedback_data_id: FeedbackDataId,
                    flags: flags,
                    role: role,
                };

                let responsedata = await postFeedbackResponse(insertdata);
                
                if (responsedata.data.status == 200) {
                    if (responsedata?.data?.ResponseData.length > 0) {
                        let notificationids = [];
                        notificationids.push(responsedata?.data?.ResponseData[0]);

                        let emp = [];
                        notificationids[0].map((obj, index) => {
                            if (!emp.includes(obj.emp_id)) {
                                emp.push(obj.emp_id);
                            }
                        });
                        /**
                         * PC_EDF_12 trigger the feeback disagreed notification to hr manager
                         */
                        let value = empId;
                        
                        await NotificationTrigger(
                            {
                                title: 'Feedback',
                                message: 'Feedback has been disagreed',
                                route: `Feedback?EmpId=${value}&FeedbackId=${FeedbackId}&EvaluationId=${EvaluationId}&IsMainGrid=true`,
                                state: {},
                                to_employee: emp,
                                by: login_emp_id,
                            },
                            emp,
                            props.websocket
                        );
                    }

                    let valiclearoption = {
                        Comments: '',
                    };
                    setFeedbackdata(valiclearoption);
                    props.Reload();
                    cancelClick();
                }
            }
        } catch (e) {
            throw e;
        }
    };

    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)' }} hidden={hideForm}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <label className="form-label hive-form-label" id="AddFeedbackDetailsPopupLabel">
                            Disagree comments<span className="hive-form-mandatory">*</span>
                        </label>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => cancelClick()}
                        />
                    </div>
                    <div className="modal-body">
                        <div className="row mb-4">
                            <div className="col-md-12">
                                <textarea
                                    className="form-control hive-form-control"
                                    id="Drop-your-comments"
                                    name="Comments"
                                    value={feedbackdata.Comments}
                                    onChange={(e) => {
                                        OnChangeName(e);
                                    }}
                                />
                                <label className="hive-form-mandatory">{message.Comments}</label>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer border-0">
                        <button type="button" className="btn hive-btn-secondary" data-bs-dismiss="modal" onClick={() => cancelClick()}>
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn hive-btn-primary"
                            onClick={() => {
                                submitClick();
                            }}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        websocket: state.webSocketAPI,
    };
}

export default connect(mapStateToProps)(EmpDisagreeFeedback);
